<template>
  <div>
    <button class="btn btn-primary btn-sm" id="show-modal" @click="showModal = true"><i class="fa fa-file-pdf-o"></i></button>
    <!-- use the modal component, pass in the prop -->
    <correspondence-modal v-if="showModal" @close="showModal = false">
      <!--
        you can use custom content here to overwrite
        default content
      -->
      <h3 slot="header">{{ agreement.correspondence_filename }}</h3>
    </correspondence-modal>
  </div>
</template>

<script>
import CorrespondenceModal from "./CorrespondenceModal";
import { mapState } from "vuex";

export default {
  name: "view-correspondence-button",
  computed: mapState(["agreement"]),
  components: { CorrespondenceModal },
  data: function() {
    return {
      showModal: false
    };
  },
  methods: {}
};
</script>
